import { Col, Form, Row, Image, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useEffect, useState, useCallback } from "react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
// import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import OrderModal from "../component/OrderModal";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import ReactLoading from "react-loading";
import SessionUtil from "../util/SessionUtil";

const CustomRow = ({ rowData, columnNames, handleClickRow }) => {
  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index} onClick={() => handleClickRow(rowData)}>
          {columnName === "itemsNo" ? (
            <span>#{rowData.Id}</span>
          ) : columnName === "quantity" ? (
            <span>{rowData.Quantity}</span>
          ) : columnName === "PriceWithProfit" ? (
            rowData.ItemPriceWithProfit === null ? (
              "---"
            ) : (
              "$ " + rowData.ItemPriceWithProfit
            )
          ) : columnName === "itemPrice" ? (
            "$ " + rowData?.ItemPrice ? (
              "$ " + rowData.ItemPrice
            ) : (
              "---"
            )
          ) : columnName === "Image" ? (
            rowData?.ItemImage ? (
              <div className="dimension-40">
                <Image
                  alt="image"
                  src={rowData.ItemImage}
                  className="img-fluid"
                />
              </div>
            ) : (
              <div className="img-empty"></div>
            )
          ) : columnName === "Status" ? (
            rowData.StatusCode === "ACTIVE" ||
            rowData.StatusCode === "Approval" ? (
              <div className="status status-success">
                <p className="mb-0">{t("Accepted")}</p>
              </div>
            ) : rowData.StatusCode === "INACTIVE" ||
              rowData.StatusCode === "Reject" ? (
              <div className="status status-failed">
                <p className="mb-0">{t("Rejected")}</p>
              </div>
            ) : (
              <div className="status status-warning">
                <p className="mb-0">{t("Pending")}</p>
              </div>
            )
          ) : (
            <p className="mb-0">
              {rowData?.[columnName] ? rowData[columnName] : "---"}
            </p>
          )}
        </td>
      ))}
    </tr>
  );
};

const Items = () => {
  const { t } = useTranslation();
  const lang = sessionStorage.getItem("lang");
  const location = useLocation();
  const { state } = location;
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [rowData, setRowData] = useState({});
  const [validated, setValidated] = useState(false);
  const [priceWithProfit, setPriceWithProfit] = useState("");
  const [status, setStatus] = useState("");
  const columnNames = [
    "itemsNo",
    "Image",
    "ItemNameEn",
    "ItemNameAr",
    "quantity",
    "itemPrice",
    "PriceWithProfit",
    "Status",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);
  const [alertMsgPrice, setAlertMsgPrice] = useState("");
  const [isPriceError, setIsPriceError] = useState(null);
  const [msgPriceError, setMsgPriceError] = useState("");

  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
  const handleClickRow = (data) => {
    setModalShow(true);
    setRowData(data);
    setAlertMsgPrice("");
    setAlertMsg(null);
    if (state.type === "all") {
      setPriceWithProfit(
        data.ItemPriceWithProfit === 0 ? "" : data.ItemPriceWithProfit
      );
      setStatus(
        data.StatusCode === "INACTIVE" || data.StatusCode === "Reject"
          ? "Reject"
          : "Approval"
      );
    }
  };
  const validatedPrice = (priceWithProfit) => {
    if (status !== "Reject") {
      setValidated(false);
      if (priceWithProfit) {
        if (priceWithProfit >= rowData.ItemPrice) {
          setIsPriceError(false);
          setValidated(true);
        } else {
          setMsgPriceError(
            t("Price with profit must be greater than or equal to price")
          );
          setIsPriceError(true);
        }
      } else {
        setMsgPriceError("");
      }
    } else {
      setPriceWithProfit(0);
      setMsgPriceError("");
      setValidated(false);
      setIsPriceError(false);
    }
  };
  const handleChangePrice = (e) => {
    const price = e.target.value;
    setPriceWithProfit(price);
    validatedPrice(price);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
    }
    setValidated(true);
    if (status !== "Reject") {
      if (priceWithProfit && status) {
        setAlertMsg(true);
        approveRejectItem();
      } else {
        validatedPrice(priceWithProfit);
      }
    } else if (status === "Reject") {
      setAlertMsg(false);
      approveRejectItem();
      setAlertMsgPrice(t("This product has been rejected"));
    }
  };

  const handleStatus = (e) => {
    const value = e.target.value;
    setStatus(value);
    if (value === "Reject") {
      setPriceWithProfit("");
      setMsgPriceError("");
      setValidated(false);
      setIsPriceError(false);
    }
  };
  const approveRejectItem = async () => {
    setLoadingSubmit(true);
    let params = {
      Id: rowData.Id,
      ItemPriceWithProfit: status === "Reject" ? 0 : priceWithProfit,
      StatusCode: status === "Reject" ? "INACTIVE" : "ACTIVE",
    };
    const res = await ApiUtil.postApi(
      state.type === "new"
        ? ApiPath.APPROOVE_ITEM
        : ApiPath.UPDATE_PRICE_WITH_PROFIT,
      params,
      "POST"
    );
    if (res.IsSuccessfull) {
      setLoadingSubmit(false);
      setModalShow(false);
      setValidated(false);
      getApi();
      setCurrentPage(1);
      setPriceWithProfit("");
      setStatus(null);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);
    } else {
      setAlertMsgPrice("");
      setAlertMsg(false);
      onHide();
    }
  };

  const getApi = useCallback(async () => {
    let statusCode =
      state.type === "new"
        ? { StoreId: parseInt(state.id), StatusCode: "PENDING" }
        : { StoreId: parseInt(state.id), StatusCode: "ACTIVE,INACTIVE" };
    let params = {
      PageNumber: currentPage,
      PageSize: 10,
      OrderBy: "Id Desc",
      ItemsView: statusCode,
    };

    const res = await ApiUtil.postApi(ApiPath.GET_ALL_ITEM, params, "POST");
    if (res.IsSuccessfull) {
      const totalPage = Math.ceil(res.Result.RecordCount / 10);
      setSortedData(res.Result.Items);
      setRecordCount(totalPage);
      setLoading(false);
    }
  }, [currentPage, state.id, state.type]);
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [getApi, isLoggedIn]);

  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const onHide = () => {
    setModalShow(false);
    setPriceWithProfit("");
    setStatus(null);
    setValidated(false);
    setLoadingSubmit(false)
  };
  return (
    <>
      <Row className="g-0 justify-content-center">
        {!loading ? (
          <Col lg={10} className="position-relative">
            <div className=" mt-4 d-flex justify-content-between gap-2">
              <div className="flex-gap-2">
                {/* <Nav.Link href={`/stores-list`}>
                  {lang === "ar" ? (
                    <IoMdArrowRoundForward size={20} />
                  ) : (
                    <IoMdArrowRoundBack size={20} />
                  )}
                </Nav.Link> */}
                <p className="title mb-0">{t("Store Items")} </p>
              </div>
            </div>
            {alertMsg !== null &&
              (alertMsg ? (
                <Alert variant={"success"} className="mt-3">
                  {state.type === "new"
                    ? t("PriceWithProfitAddedSuccessfully")
                    : t("PriceWithProfitUpdatedSuccessfully")}
                </Alert>
              ) : alertMsgPrice && !alertMsg ? (
                <Alert variant={"danger"} className="mt-3">
                  {alertMsgPrice}
                </Alert>
              ) : (
                <Alert variant={"danger"} className="mt-3">
                  {t("errorPriceWithProfit")}
                </Alert>
              ))}

            <TableComp
              data={sortedData}
              columnNames={columnNames}
              setSortedData={setSortedData}
              page="item"
              withoutAction={true}
            >
              {sortedData.map((rowData, index) => (
                <CustomRow
                  key={index}
                  rowData={rowData}
                  columnNames={columnNames}
                  handleClickRow={handleClickRow}
                />
              ))}
            </TableComp>
            <Pagination
              current={currentPage}
              total={recordCount}
              onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
              extraClassName="justify-content-end"
            />
          </Col>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>

      <OrderModal show={modalShow} onHide={onHide} data={rowData} page="items">
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Form.Group className="my-3" controlId="formGroupPriceWithProfit">
            <Form.Label className="font-SemiBold">
              {t("PriceWithProfit")}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Enter") + " " + t("PriceWithProfit")}
              value={priceWithProfit}
              inputMode="numeric"
              onKeyPress={(e) => {
                // Allow numbers, a single decimal point, and backspace
                if (!/[0-9.]/.test(e.key) && e.key !== "Backspace") {
                  e.preventDefault();
                }
                // Prevent multiple decimal points
                if (e.key === "." && priceWithProfit.includes(".")) {
                  e.preventDefault();
                }
              }}
              pattern="^\d*\.?\d*$"
              onChange={(e) => handleChangePrice(e)}
              isInvalid={isPriceError}
              required={status !== "Reject"}
              disabled={status === "Reject"}
            />

            <Form.Control.Feedback type="invalid">
              {msgPriceError === ""
                ? t("Please enter") + " " + t("PriceWithProfit")
                : msgPriceError}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Label className="font-SemiBold">
            {t("Select Status")} :{" "}
          </Form.Label>
          <Form.Check
            inline
            type={"radio"}
            id={`radio`}
            label={t("Accept")}
            name="status"
            className="mx-3"
            value={"Approval"}
            onChange={handleStatus}
            checked={status === "Approval"}
            required
          />

          <Form.Check
            inline
            type={"radio"}
            id={`radio`}
            label={t("Reject")}
            name="status"
            value={"Reject"}
            onChange={handleStatus}
            checked={status === "Reject"}
            required
          />

          <div className="d-flex justify-content-end">
            <Button
              aria-label="Aria label"
              type="submit"
              className="btn-main"
              disabled={loadingSubmit}
            >
              <div className="flex-gap-2 justify-content-center">
                {state.type === "new" ? t("Save") : t("Update")}
                {loadingSubmit && (
                  <ReactLoading
                    type={"spin"}
                    color={"#c8c8c8"}
                    height={"20px"}
                    width={"20px"}
                  />
                )}
              </div>
            </Button>
          </div>
        </Form>
      </OrderModal>
    </>
  );
};

export default Items;
